import { ROUTE_NAMES, ROUTE_GROUPS } from '@atlassian/jira-common-constants/src/spa-routes';
import type { Route } from '@atlassian/jira-router';
import type {
	NavigationOverview,
	NavigationProject,
} from '@atlassian/jira-router-resources-business-navigation';

export const getOverviewUrl = (overview: NavigationOverview, currentRoute?: Route) => {
	switch (currentRoute?.name) {
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_SUMMARY:
			return `/jira/core/overviews/${overview.id}/summary`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_CALENDAR:
			return `/jira/core/overviews/${overview.id}/calendar`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_TIMELINE:
			return `/jira/core/overviews/${overview.id}/timeline`;
		default: {
			return `/jira/core/overviews/${overview.id}`;
		}
	}
};

// TODO: Remove when cleaning 'jwm.custom-project-navigation' feature flag
export const getProjectUrl = (project: Pick<NavigationProject, 'key'>, currentRoute?: Route) => {
	switch (currentRoute?.name) {
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_SUMMARY:
			return `/jira/core/projects/${project.key}/summary`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_BOARD:
			return `/jira/core/projects/${project.key}/board`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_LIST:
			return `/jira/core/projects/${project.key}/list`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_CALENDAR:
			return `/jira/core/projects/${project.key}/calendar`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_TIMELINE:
			return `/jira/core/projects/${project.key}/timeline`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_FORM:
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_FORM_BUILDER:
			return `/jira/core/projects/${project.key}/form`;
		case ROUTE_NAMES.PROJECT_PAGES:
			return `/jira/core/projects/${project.key}/pages`;
		case ROUTE_NAMES.CLASSIC_BUSINESS_PROJECT_ATTACHMENTS:
			return `/jira/core/projects/${project.key}/attachments`;
		default: {
			if (currentRoute?.group === ROUTE_GROUPS.ISSUE_NAVIGATOR) {
				return `/jira/core/projects/${project.key}/issues`;
			}

			return `/jira/core/projects/${project.key}`;
		}
	}
};
